
export function dzstoggle_initalltoggles() {
  jQuery('.dzstoggle').each(function () {
    var _t = jQuery(this);
    if (_t.hasClass('inited')) {
      return;
    } else {
      dzstoggle_inittoggle(_t);
    }
  });
}

function dzstoggle_inittoggle(arg) {
  arg.addClass('inited');
  arg.children('.toggle-title').bind('click', click_toggletitle);
  arg.children('.toggle-title').prepend('<div class="arrow-down"><svg height="15px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M98.9,184.7l1.8,2.1l136,156.5c4.6,5.3,11.5,8.6,19.2,8.6c7.7,0,14.6-3.4,19.2-8.6L411,187.1l2.3-2.6  c1.7-2.5,2.7-5.5,2.7-8.7c0-8.7-7.4-15.8-16.6-15.8v0H112.6v0c-9.2,0-16.6,7.1-16.6,15.8C96,179.1,97.1,182.2,98.9,184.7z"/></svg></div>');
  if (arg.prop('class').indexOf('skin-') === -1) {
    arg.addClass('skin-default');
  }
  if (arg.prop('class').indexOf('transition-') === -1) {
  }

  function click_toggletitle() {
    var _t = jQuery(this);
    var cthis = _t.parent();
    var cont = cthis.children('.toggle-content');

    var conth = cont.outerHeight();
    cthis.css({
      height: ''
    })
    if (cthis.hasClass('active')) {
      cthis.removeClass('active');
      if (cthis.hasClass('skin-default')) {
        cont.css({'height': conth, 'display': 'block'});
        setTimeout(function () {
          cont.css({'height': 0});
        }, 20);

      }
    } else {
      cthis.addClass('active');
      conth = cont.outerHeight();
      if (cthis.hasClass('skin-default')) {
        cont.css({'height': 'auto'});
        conth = cont.outerHeight() + 30;
        cont.css({'height': 0, 'display': 'block'});
        setTimeout(function () {
          cont.css({'height': conth});
        }, 20);

        setTimeout(function () {
          cont.css({'height': 'auto'});
        }, 500);
      }
    }
  }
}